export const START_CONTENT_GAP = 2
export const DEFAULT_CONTENT_GAP = 1
